import { render } from "./OffcanvasRecipeForm.vue?vue&type=template&id=6d158108"
import script from "./OffcanvasRecipeForm.vue?vue&type=script&lang=js"
export * from "./OffcanvasRecipeForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__